<template>
    <Map class="animated fadeIn" type="Nước mặt" config-key="nuoc_mat" />
</template>

<script>
import Map from '@/components/Map';

export default {
    components: {
        Map
    }
};
</script>
